import { useAppSelector } from 'store/index';

export const useNewCategory = () => {
    return useAppSelector(
        ({ categories: { new: newCategory } }) => newCategory
    );
};
